import {Component, OnInit} from '@angular/core';
import {Score} from '../../domain/score';
import {ScoreService} from '../../services/score.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfigService} from '../../services/config.service';
import {Observable} from 'rxjs';
import {Config} from '../../domain/config';

@Component({
  selector: 'tech-core-quiz-score',
  standalone: false,
  templateUrl: './score.component.html',
  styleUrl: './score.component.scss'
})
export class ScoreComponent implements OnInit {

  rewardMessage = ""
  config$: Observable<Config> | undefined
  scores: Score[] = [];
  loading: boolean = true;
  userName: string = "";
  userScore: string = "";
  hasQueryParam: boolean = false;
  rank: string = "X"

  constructor(
    private scoreService: ScoreService,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.config$ = this.configService.getConfig()

    this.route.queryParams.subscribe(params => {
      this.userName = params['userName'];

      this.hasQueryParam = !!(params['userName'])

      console.log("Received Username:", this.userName);
    });


    if (this.hasQueryParam) {
      this.scoreService.getUserScoreWithRank(this.userName).subscribe({
        next: (data) => {
          if (data != null) {
            this.rank = data.rank
            this.userName = data.userName
            this.userScore = data.score
          }
        }, error: err => {
          console.log("Something went wrong fetching userScore with Rank")
        }
      });
    }

    this.scoreService.getTop3Scores().subscribe({
      next: (data) => {
        this.scores = data
          .map((score, index) => ({
            ...score,
            rank: (index + 1).toString()
          }))
          .sort((a, b) => Number(b.score) - Number(a.score));
        this.loading = false;
      }, error: err => {
        console.error(err);
        this.loading = false;
      }
    })


  }

  navigateToSplash() {
    this.router.navigate(['/splash']);
  }

}
